import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserPlus } from "@phosphor-icons/react";
import { registerUser, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../context/AuthContext";

const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const { refresh } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await registerUser({ email, password, name });
      await refresh();
      navigate("/subscribe", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="signup-page" className="mx-auto flex min-h-[80vh] max-w-sm flex-col justify-center px-4 py-16">
      <div className="mb-8 text-center">
        <Link to="/" className="font-heading text-2xl font-black uppercase tracking-tighter text-white">
          EDGE<span className="text-eb-accent">BALL</span>
        </Link>
        <h1 className="mt-4 font-heading text-xl uppercase tracking-tight text-white">Create Account</h1>
      </div>
      <form onSubmit={handleSubmit} className="flex flex-col gap-3 rounded-lg border border-white/10 bg-eb-surface p-6">
        {error && (
          <p data-testid="signup-error" className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-400">
            {error}
          </p>
        )}
        <input
          data-testid="signup-name-input"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Name (optional)"
          className="rounded-md border border-white/10 bg-eb-bg px-3 py-2 text-sm text-white placeholder:text-zinc-600 focus:border-eb-accent focus:outline-none"
        />
        <input
          data-testid="signup-email-input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className="rounded-md border border-white/10 bg-eb-bg px-3 py-2 text-sm text-white placeholder:text-zinc-600 focus:border-eb-accent focus:outline-none"
        />
        <input
          data-testid="signup-password-input"
          type="password"
          required
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password (min 8 characters)"
          className="rounded-md border border-white/10 bg-eb-bg px-3 py-2 text-sm text-white placeholder:text-zinc-600 focus:border-eb-accent focus:outline-none"
        />
        <button
          data-testid="signup-submit-button"
          type="submit"
          disabled={submitting}
          className="mt-2 flex items-center justify-center gap-2 rounded-md bg-eb-accent px-4 py-2 font-heading text-sm uppercase tracking-wide text-white transition-colors hover:bg-blue-600 disabled:opacity-50"
        >
          <UserPlus size={16} weight="bold" /> {submitting ? "Creating account\u2026" : "Sign Up"}
        </button>
      </form>
      <p className="mt-4 text-center text-sm text-zinc-500">
        Already have an account?{" "}
        <Link to="/login" data-testid="signup-login-link" className="text-eb-accent hover:underline">
          Log in
        </Link>
      </p>
    </div>
  );
};

export default Signup;
